<script lang="ts">
import { PropType, defineComponent, computed } from 'vue'
import { Illust } from '../../../libs/models'
import { useCurrentUserStore } from '../libs/currentUserStore'
import { useApi } from '../libs/api'
import TextDeleteButton from './TextDeleteButton.vue'
import { l } from '../libs/localization'

export default defineComponent({
  components: { TextDeleteButton },
  emits: ['deleted'],
  props: {
    illust: { type: Object as PropType<Illust>, required: true }
  },
  setup (props, { emit }) {
    const api = useApi()
    const currentUserStore = useCurrentUserStore()
    const isOwn = computed(() => props.illust.user_id === currentUserStore.value?.id)
    const deleteIllust = () => {
      if (!confirm(l('このイラストを削除してよろしいですか？（一度削除したイラストは元に戻せません）'))) return
      api.post(`/illusts/${props.illust.id}/delete`).then(() => {
        emit('deleted')
      })
    }
    return {
      isOwn,
      deleteIllust
    }
  }
})
</script>

<template>
  <TextDeleteButton v-if="isOwn" :label="l('イラストを削除')" @click="deleteIllust" />
</template>
